import classNames from 'classnames';
import { observer } from 'mobx-react';
import { FC, PropsWithChildren } from 'react';

import { Flex, Icon, Text } from '@servicetitan/anvil2';
import IconAtlasLogo from '@servicetitan/anvil2/assets/icons/st/atlas_logo.svg';

import * as Styles from './message-row.module.less';
import { formatTime } from '../../utils/format-date';

export interface MessageRowProps {
    isMine: boolean;
    name?: string;
    showAvatar?: boolean;
    date?: Date;
}

export const MessageRow: FC<PropsWithChildren<MessageRowProps>> = observer(
    ({ children, isMine, showAvatar, date, ...rest }) => {
        return (
            <Flex
                className={classNames(Styles.messageRow, 'w-100-i')}
                gap="2"
                direction={isMine ? 'row-reverse' : 'row'}
                {...rest}
            >
                {!isMine && (
                    <div className={Styles.messageRowAvatarWrapper} data-cy="avatar-icon">
                        {showAvatar && <Icon svg={IconAtlasLogo} size="large" />}
                    </div>
                )}
                <Flex
                    alignItems={isMine ? 'flex-end' : 'flex-start'}
                    direction="column"
                    className="w-100"
                >
                    {children}
                    {date && (
                        <Text variant="eyebrow" className="m-t-1">
                            {formatTime(date)}
                        </Text>
                    )}
                </Flex>
            </Flex>
        );
    }
);
